<template>
  <transition-group name="messages-list" tag="div">
    <div
      v-for="(message, objKey, index) in feed"
      :key="objKey"
      class="messages-list-item"
    >
      <message-own
        v-if="message.id === authorId"
        :msgstyle="message.msgstyle"
        :date="message.date"
        :image-url="message.imageUrl"
        :contents="message.contents"
      />
      <message-foreign
        v-else
        :msgstyle="message.msgstyle"
        :author="message.author"
        :date="message.date"
        :image-url="message.imageUrl"
        :contents="message.contents"
        :blah="index"
      />
    </div>
  </transition-group>
</template>

<script>
import MessageOwn from "./MessageOwn.vue";
import MessageForeign from "./MessageForeign.vue";

export default {
  name: "MessagesList",
  components: {
    MessageOwn,
    MessageForeign,
  },
  props: {
    feed: {
      type: Array,
      default: function () {
        return [];
      },
      required: false,
    },
    authorId: {
      type: Number,
      default: 0,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
